
import React, { useState, useEffect } from 'react'

import { useParams, Link, useNavigate } from 'react-router-dom'
import {  Col, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import { fetchCustomerDetails, updateCustomerAction } from '../actions/productActions';

import Loader from '../components/Loader'
import Message from '../components/Message'
import PersianText from '../components/PersianText'

function CustomerScreen() {
    const history = useNavigate()
    const { id } = useParams()
    const dispatch = useDispatch()

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin


    const customerDetails = useSelector(state => state.customerDetails)
    const { error: errorOfcustomerDetails, loading: loadingOfcustomerDetails, customers } = customerDetails

    const updateCustomer = useSelector(state => state.updateCustomer)
    const { error: errorOfupdateCustomer, loading: loadingOfupdateCustomer, updateThisCustomer } = updateCustomer

    const [qty, setQty] = useState(1)

    var loading = false
    var error = ''

    if (loadingOfcustomerDetails || loadingOfupdateCustomer) {
        loading = true
    }

    if (errorOfcustomerDetails) {
        error = errorOfcustomerDetails
    } else if (errorOfupdateCustomer) {
        error = errorOfupdateCustomer
    }

    useEffect(() => {

        if (!userInfo) {
            history('/login')
        }

        dispatch(fetchCustomerDetails(id))

    }, [history, userInfo, error, dispatch, id])



    const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده
    const [selectedCode, setselectedCode] = useState(""); // ذخیره گزینه انتخاب‌شده
    const [message, setMessage] = useState('')
    const [dangerMessage, setDangerMessage] = useState('')

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };
    
    // ارسال فرم
    const handleSubmit = (e) => {
        e.preventDefault();
        setDangerMessage('')
        setMessage('')
        if(selectedOption == "3" && customers.isProblem){setDangerMessage('وضعیت قبلا در حالت عدم تحویل قرار گرفته است')}
        else if(selectedOption == "2" && customers.isDelivered){setDangerMessage('وضعیت قبلا در حالت  تحویل شده  قرار گرفته است')}
        else if(selectedOption == "1" && customers.isReady){setDangerMessage('وضعیت قبلا در حالت آماده ارسال  قرار گرفته است')}
        else{
        if (!selectedOption && !selectedCode) {
            setDangerMessage('لطفا یک مورد را انتخاب کنید !')
        } else {
            if (selectedOption == "3" || selectedCode) {
                if (selectedCode) {
                    if (selectedOption == "3") {
                        dispatch(updateCustomerAction(
                            {
                                "trackCode": customers.track_code,
                                "option": selectedOption,
                                "deliverText": selectedCode,
                            }
                        ))
                        setMessage('توضیحات و عدم تحویل با موفقیت ثبت شد .')
                    } else { setDangerMessage('توضیحات را فقط برای عدم تحویل پر کنید') }

                } else { setDangerMessage('با انتخاب عدم تحویل باید توضیحات وارد کنید') }
            } else {
                
                dispatch(updateCustomerAction(
                    {
                        "trackCode": customers.track_code,
                        "option": selectedOption,
                        "deliverText": "",
                    }
                ))
                if (selectedOption == "1") { setMessage('عملیات آماده ارسال با موفقیت انجام شد .') }
                if (selectedOption == "2") { setMessage('عملیات تحویل شده با موفقیت انجام شد') }
                if (selectedOption == "4") { setMessage('عملیات پرداخت شده با موفقیت انجام شد') }

            }
        }
        setSelectedOption('')
        setselectedCode('')
        // عملیات مرتبط با داده‌های چک‌باکس
    }};


    return (
        <div>
            <Link className='btn btn-light my-3' to="/abfa">بازگشت </Link>

            {loading ? <Loader />
                : error ? <Message variant='danger' text={error} />
                    :
                    (<Row>

                        <Col sm={12} md={6} lg={6} xl={6}>
                            <div className="table-responsive ">
                                <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
                                    <thead>

                                    </thead>
                                    <tbody>

                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                               وضعیت
                                            </td>
                                            <td className='table-warning'>
                                                {customers.isProblem?"عدم تحویل":
                                                customers.isPaid?
                                                    customers.isReady?
                                                        customers.isDelivered?
                                                            "تحویل شده"
                                                            :"آماده ارسال"
                                                        :"پرداخت شده"
                                                    :"پرداخت نشده"
                                                   
                                                    }
                                            </td>
                                        </tr>

                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                کد رهگیری
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText> {customers.track_code}</PersianText>
                                            </td>
                                        </tr>

                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                نام
                                            </td>
                                            <td className='table-warning'>
                                                {customers.customer?.name}
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                آدرس
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.customer?.address}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                 آدرس جدید
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.addresses?.newAddress || '—'}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                شماره تلفن
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText> {customers.customer?.phone_number}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                کد پستی
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.customer?.postalcode}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                 کد پستی جدید
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.addresses?.newPostalcode || '—'}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                محدوده
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.customer?.area?.name}</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                مبلغ پرداخت شده
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>   {customers.gov_price}  ریال</PersianText>
                                            </td>
                                        </tr>
                                        <tr className='table-warning'>
                                            <td className='table-warning text-danger'>
                                                توضیحات
                                            </td>
                                            <td className='table-warning'>
                                            <PersianText>  {customers.description}</PersianText>
                                            </td>
                                        </tr>

                                    </tbody>
                                </Table></div>
                        </Col>
                        {userInfo.name == "user" || userInfo.name == "mina" ? (
                            <Col sm={12} md={6} lg={6} xl={6} className='border border-secondary p-4' >
                                <div>
                                    {
                                        message ?
                                            updateThisCustomer.success ?
                                                <Message variant='success' text={message} /> : <Message variant='danger' text="خطایی رخ داده است" /> :
                                            dangerMessage ? <Message variant='danger' text={dangerMessage} /> : ""
                                    }
                                    <form onSubmit={handleSubmit}>
                                        <p className='large'>وضعیت مورد نظر را انتخاب کنید :</p>
                                        {userInfo.name == "mina" ? (
                                        <div>
                                            <input
                                                type="radio"
                                                name="option"
                                                value="4"
                                                checked={selectedOption === "4"}
                                                onChange={handleOptionChange}
                                            /><label className='p-1'>
                                               پرداخت شده
                                            </label>
                                        </div>):""}
                                        <div>
                                            <input
                                                type="radio"
                                                name="option"
                                                value="1"
                                                checked={selectedOption === "1"}
                                                onChange={handleOptionChange}
                                            /><label className='p-1'>
                                                آماده ارسال
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                name="option"
                                                value="2"
                                                checked={selectedOption === "2"}
                                                onChange={handleOptionChange}
                                            /><label className='p-1'>
                                                تحویل شده
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                name="option"
                                                value="3"
                                                checked={selectedOption === "3"}
                                                onChange={handleOptionChange}
                                            /><label className='p-1'>
                                                عدم تحویل
                                            </label>
                                        </div>
                                        <div>
                                            <label className='p-1 disc'>
                                                * در صورت انتخاب عدم تحویل توضیح آن الزامی است
                                            </label>
                                            <textarea
                                                class="form-control border border-secondary" aria-label="With textarea"
                                                type="text"
                                                name="option"
                                                value={selectedCode}
                                                onChange={(e) => setselectedCode(e.target.value)}
                                                //rows="5" // تعداد ردیف‌ها
                                                //cols="40" // تعداد ستون‌ها
                                                placeholder="توضیحات ..."
                                            />

                                        </div>
                                        <div className="d-grid gap-2 d-md-block col-3 p-3">
                                            <button className="btn btn-primary" type="submit">تایید</button>
                                        </div>
                                    </form>
                                </div>    </Col>) : ""}
                    </Row>


                    )
            }


        </div>
    )
}

export default CustomerScreen
